import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Phone, Droplets } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_TEL, BRAND } from '@/lib/site';
import { trackCallClick } from '@/lib/analytics';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/areas', label: 'Areas' },
  { to: '/resources', label: 'Resources' },
  { to: '/contact', label: 'Contact' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-white/90 backdrop-blur">
      <div className="container-page flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-navy-deep text-water">
            <Droplets className="h-5 w-5" strokeWidth={2.2} />
          </span>
          <div className="leading-tight">
            <div className="font-display text-[15px] font-extrabold tracking-tight text-primary">{BRAND}</div>
            <div className="text-[10px] uppercase tracking-widest text-muted-foreground">24/7 Emergency • Tri-Cities BC</div>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-semibold transition ${isActive ? 'bg-water-light text-water-strong' : 'text-primary/80 hover:text-primary hover:bg-secondary'}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          <a href={PHONE_TEL} onClick={() => trackCallClick('header-desktop')} className="inline-flex items-center gap-2 rounded-full bg-navy-deep px-4 py-2 text-sm font-bold text-white transition hover:bg-navy">
            <Phone className="h-4 w-4" strokeWidth={2.4} /> {PHONE_DISPLAY}
          </a>
        </div>
        <button className="lg:hidden rounded-lg p-2 text-primary" onClick={() => setOpen(!open)} aria-label="Menu" aria-expanded={open} aria-controls="mobile-navigation">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div id="mobile-navigation" className="lg:hidden border-t border-border bg-white">
          <div className="container-page py-3 flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm font-semibold transition ${isActive ? 'bg-water-light text-water-strong' : 'text-primary/80 hover:bg-secondary'}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <a href={PHONE_TEL} onClick={() => trackCallClick('header-mobile')} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-navy-deep px-4 py-3 text-sm font-bold text-white">
              <Phone className="h-4 w-4" /> {PHONE_DISPLAY}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
